var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{on:{"page:afterin":function($event){_vm.pageAnimationEnded = true}}},[(_vm.pageAnimationEnded)?_c('person-table',{staticClass:"mx-10",attrs:{"loadedData":_vm.loadedData,"persons":_vm.persons,"showActionBar":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }